import { Container } from 'react-bootstrap'
import { tenantEntity } from '@/entities'
import { useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

interface CrossLinkingPartnerInfo {
  name: string
  domain: string
}

interface Props {
  trackingStringPrefix: string
}

const TravelFilterPartnerHint = ({ trackingStringPrefix }: Props) => {
  const { t } = useTranslation('common')
  const router = useRouter()
  const [crossLinkingPartnerTenants, setCrossLinkingPartnerTenants] = useState<CrossLinkingPartnerInfo[]>([])

  useEffect(() => {
    const fetchTenant = async () => {
      const ownTenantId = process.env.NEXT_PUBLIC_TENANT_ID
      const data = await tenantEntity.repository.getObject(ownTenantId, {
        withPartnerTenants: true,
        withPartnerTenantsTenant: true,
      })

      const filteredPartners = (data?.partnerTenants ?? [])
        .filter((partner: any) => partner?.filterCrossLinking && String(partner?.tenant?.id) !== String(ownTenantId))
        .map((partner: any) => ({
          name: partner.tenant?.name,
          domain: partner.tenant?.domain,
        }))
        .filter((p: CrossLinkingPartnerInfo) => p.name && p.domain)

      setCrossLinkingPartnerTenants(filteredPartners)
    }

    void fetchTenant()
  }, [])

  const buildUrl = (domain: string) => {
    const baseUrl = `https://${domain}/de/tours`
    const months = router.query.months as string | undefined
    const params = new URLSearchParams()

    if (months) {
      params.set('months', months)
      // params.set('resetOnEmpty', '1')
      return `${baseUrl}?${params.toString()}`
    } else {
      return baseUrl
    }
  }

  const linkList = crossLinkingPartnerTenants.map(
    ({ name, domain }) =>
      `<a data-tr-click="${trackingStringPrefix}:travel_partner:click" href="${buildUrl(
        domain
      )}" target="_blank" rel="noopener noreferrer">${name}</a>`
  )

  const linkString = linkList.length === 1 ? linkList[0] : linkList.slice(0, -1).join(', ') + ' oder ' + linkList[linkList.length - 1]

  return (
    <Container>
      {crossLinkingPartnerTenants.length > 0 && (
        <p dangerouslySetInnerHTML={{ __html: t('travel.filter.crossLinkingHint', { tenants: linkString }) }} />
      )}
    </Container>
  )
}

export default TravelFilterPartnerHint
